/** Matches backend ReportType — sent as a number, never as a string. */
export const REPORT_TYPE = {
	Events: 1,
	Expenses: 2,
	Trips: 3,
	Infractions: 4,
	Checklist: 5,
	Vehicles: 6,
} as const;

export type ReportType = (typeof REPORT_TYPE)[keyof typeof REPORT_TYPE];

/** Date-only format accepted by the API: "YYYY-MM-DD". */
export type IsoDate = string;

export type GenerateReportRequest = {
	type: ReportType;
	initialDate?: IsoDate | null;
	finalDate?: IsoDate | null;
	pullAllSinceStart?: boolean;
	vehicleIds?: number[];
	driverIds?: number[];
	eventTypeIds?: number[];
	expenseTypeIds?: number[];
	templateIds?: number[];
};

export type ExportResponse = {
	id: number;
	message: string | null;
};

export type BuildGenerateReportRequestInput = {
	type: ReportType;
	initialDate?: IsoDate | null;
	finalDate?: IsoDate | null;
	pullAllSinceStart?: boolean;
	vehicleIds?: number[];
	driverIds?: number[];
	eventTypeIds?: number[];
	expenseTypeIds?: number[];
	templateIds?: number[];
};
